export function formatSmartUSD(num) {
  const val = Number(num || 0);
  return `${val < 0 ? "-" : ""}$${Math.abs(val).toLocaleString(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })}`;
}

export function formatSmartTHB(num) {
  const val = Number(num || 0);
  return `${val < 0 ? "-" : ""}฿${Math.abs(val).toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })}`;
}

export function formatPriceUSD(num) {
  const val = Number(num || 0);
  return `${val < 0 ? "-" : ""}$${Math.abs(val).toLocaleString(undefined, {
    minimumFractionDigits: 4, maximumFractionDigits: 4,
  })}`;
}

export function formatShares(num) {
  return Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 7, maximumFractionDigits: 7,
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";
  
  let cleanStr = String(dateString).replace("T", " ");

  const parts = cleanStr.match(/(\d+)-(\d+)-(\d+)\s+(\d+):(\d+):(\d+)/);
  
  if (!parts) {
    const fallbackDate = new Date(dateString);
    if (isNaN(fallbackDate.getTime())) return dateString;
    return fallbackDate.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" }) + " " +
           fallbackDate.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
  }

  const year = parseInt(parts[1], 10);
  const month = parseInt(parts[2], 10) - 1;
  const day = parseInt(parts[3], 10);
  const hour = parseInt(parts[4], 10);
  const minute = parseInt(parts[5], 10);

  const date = new Date(year, month, day, hour, minute);

  return (
    date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" }) + " " +
    date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  
  let cleanStr = String(dateString).replace("T", " ");
  const parts = cleanStr.match(/(\d+)-(\d+)-(\d+)/);
  
  if (!parts) {
    const fallbackDate = new Date(dateString);
    return isNaN(fallbackDate.getTime()) ? dateString : fallbackDate.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" });
  }

  const date = new Date(parseInt(parts[1], 10), parseInt(parts[2], 10) - 1, parseInt(parts[3], 10));
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" });
}

export function getSafeTimestamp(dateStr) {
  if (!dateStr) return 0;
  const str = String(dateStr);
  
  if (str.includes("/")) {
    const p = str.split("/");
    if (p.length === 3) return new Date(parseInt(p[2], 10), parseInt(p[1], 10) - 1, parseInt(p[0], 10)).getTime();
  }
  
  let cleanStr = str.replace("T", " ");
  const parts = cleanStr.match(/(\d+)-(\d+)-(\d+)\s+(\d+):(\d+):(\d+)/);
  
  if (parts) {
    return new Date(parseInt(parts[1], 10), parseInt(parts[2], 10) - 1, parseInt(parts[3], 10), parseInt(parts[4], 10), parseInt(parts[5], 10)).getTime();
  }
  
  return new Date(dateStr).getTime() || 0;
}

export function truncateWHT(gross) {
  return Math.floor(Number(gross) * 0.15 * 100) / 100;
}